import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ReferralNetworkChart = ({ data }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-xl p-4 shadow-lg">
          <p className="text-sm font-medium text-foreground mb-2">
            {payload?.[0]?.payload?.level}
          </p>
          <p className="text-sm text-muted-foreground">
            Referidos: <span className="font-semibold text-primary">
              {payload?.[0]?.value}
            </span>
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="card">
      <div className="mb-6">
        <h3 className="text-xl md:text-2xl font-semibold text-foreground font-heading mb-2">
          Red de Referidos
        </h3>
        <p className="text-sm text-muted-foreground">
          Distribución por niveles
        </p>
      </div>

      <div className="w-full h-64 md:h-80" aria-label="Gráfico de barras de red de referidos por nivel">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="level" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar 
              dataKey="count" 
              fill="var(--color-primary)" 
              radius={[8, 8, 0, 0]}
              animationDuration={1000}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ReferralNetworkChart;